import React from 'react';
import Logo from './index';

const LogoWithLink: React.FC<{size?: string, style?: React.CSSProperties}> = ({size, style}) => {
    return (
        <a href="/?index=1" style={{textDecoration: 'none'}}>
            <Logo size={size} style={style} />
        </a>
    );
};

export default LogoWithLink;